import { createAction, props } from '@ngrx/store';

import { LastPageStateUsers } from '@store/reducers/users.reducer';

export const setLastPageStateUsers = createAction(
  '[stateUsers] Set last page state',
  props<{ newPageState: Partial<LastPageStateUsers> }>(),
);
